import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PointCloudContentStore } from '../../../state/point-cloud-content-store';
import { toggleState } from '../../../utils/misc-utils';

@Component({
  selector: 'h3-toggle-edit-panel-button',
  templateUrl: './toggle-edit-panel-button.component.html',
  styleUrl: './toggle-edit-panel-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleEditPanelButtonComponent {
  private readonly store = inject(PointCloudContentStore);

  isExpanded$ = this.store('editPanel')('isExpanded').$;

  toggle() {
    toggleState(this.store('editPanel')('isExpanded'));
  }
}
